import { proxy } from 'valtio';
import { CallState, DialerState, PhoneState } from './types';
import { RecordingStatus } from './lib/getInitialRecordingState';

export const defaultCallState: CallState = {
  connected: false,
  callId: '',
  direction: '',
  ended: false,
  established: false,
  hasSession: false,
  held: false,
  inTransfer: false,
  isAudioMuted: false,
  isVideoMuted: false,
  localIdentity: '',
  originating: false,
  primary: false,
  progress: false,
  remoteIdentity: '',
  terminating: false,
  registrationFailed: false,
  internalCall: false,
  remoteCallId: '',
  lastTriggeringEvent: '',
  pcsConversationSid: '',
  queueIds: [],
  recordingState: {
    status: RecordingStatus.NOT_STARTED,
    disabled: false,
  },
};

export const callState = proxy<CallState>(defaultCallState);

export const dialerState = proxy<DialerState>({
  actionDisplay: '',
  actionColor: '#093',
  dialedNumbers: '',
});

export const phoneState = proxy<PhoneState>({
  phoneConnected: false,
  registrationFailed: false,
  callList: {},
  registrationOverwritten: false,
  /** callsAccepting holds the callIds for any calls that have been accepted, but waiting for the session delivered, it will be used to determine if we should show a loading state. */
  callsAccepting: [],
});
